import Vue from 'vue'

const eventBus = {
  install (Vue, options) {
    Vue.prototype.$bus = new Vue()
  }
}
Vue.use(eventBus)
